export default __webpack_public_path__ + "static/media/pdf-icon.5439aad8.svg";